<template>
    <div class="p-4">
        <h2>Gerenciar cursos</h2>
        <p>Adicione, atualize ou exclua cursos</p>

        <div class="flex justify-content-end mb-4">
            <Button label="Adicionar Curso" icon="pi pi-users" size="small" @click="visible = true" />
            <Button label="Excluir Curso" icon="pi pi-trash" severity="danger" size="small" class="ml-3"
                :disabled="cursosSelecionados.length == 0" @click="excluirCursos" />
        </div>
        <Toast />
        <Dialog v-model:visible="visible" modal header="Adicionar Usuário" :style="{ width: '50vw' }"
            :breakpoints="{ '960px': '75vw', '641px': '95vw' }">
            <form @submit.prevent="inserirCurso">
                <MultiSelect :options="anosDoEnsinoMedio" optionLabel="label" optionValue="value"
                    placeholder="Selecione os anos para os quais deseja disponibilizar esse curso"
                    v-model="novoCurso.anosDoEnsinoMedio" class="w-full mb-3" />

                <Dropdown :options="anosLetivos" optionLabel="ano" optionValue="id" placeholder="Ano Letivo"
                    v-model="novoCurso.anoLetivo" required class="w-full mb-3" />

                <Dropdown :options="disciplinas" optionLabel="nome" optionValue="id" placeholder="Disciplina"
                    v-model="novoCurso.disciplina" required class="w-full mb-3" />

                <MultiSelect :options="professores" optionLabel="nome" optionValue="id"
                    placeholder="Selecione os Professores do curso" v-model="novoCurso.professores"
                    class="w-full mb-3" />


                <Button :loading="loading" label="Adicionar " size="small" type="submit" />
            </form>
        </Dialog>
    </div>


    <DataTable v-if="cursos.length > 0" v-model:selection="cursosSelecionados" v-model:editingRows="editingRows"
        :value="cursos" paginator :rows="50" v-model:filters="filters" editMode="row" dataKey="id"
        @row-edit-save="onRowEditSave" stripedRows :globalFilterFields="['disciplinas']">
        <template #header>
            <div class="flex justify-content-end">
                <span class="p-input-icon-left">
                    <i class="pi pi-search" />
                    <InputText v-model="filters['global'].value" placeholder="Pesquisar usuário" />
                </span>

            </div>
        </template>
        <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>

        <Column field="anos_letivos" header="Ano Letivo" sortable>
            <template #body="slotProps">
                {{ slotProps.data.anos_letivos.ano }}
            </template>
            <template #editor="{ data, field }">

                <Dropdown v-model="data[field].id" :options="anosLetivos" optionLabel="ano" optionValue="id" autofocus
                    size="small" class="w-full" />
            </template>
        </Column>
        <Column field="anoDoEnsinoMedio" header="Ano do Ensino Médio" sortable>
            <template #body="slotProps">
                {{ valorParaAno(slotProps.data.anoDoEnsinoMedio) }}
            </template>
            <template #editor="{ data, field }">
                <Dropdown v-model="data[field]" :options="anosDoEnsinoMedio" optionLabel="label" optionValue="value"
                    autofocus size="small" class="w-full" />
            </template>
        </Column>
        <Column field="disciplinas" header="Disciplina" sortable>
            <template #body="slotProps">
                {{ slotProps.data.disciplinas.nome }}
            </template>
            <template #editor="{ data, field }">
                <Dropdown v-model="data[field].id" :options="disciplinas" optionLabel="nome" optionValue="id" autofocus
                    size="small" class="w-full" />
            </template>
        </Column>
        <Column field="cursos_professores" header="Professores" sortable>
            <template #body="slotProps">
                <ul>
                    <li v-for="professor in slotProps.data.cursos_professores" :key="professor.id">
                        {{ professor.users.nome }}
                    </li>
                </ul>

            </template>
            <template #editor="{ data, field }">
                {{ testando(data) }}
                <MultiSelect v-model="data[field]" :options="professores" optionLabel="nome" optionValue="id"
                    placeholder="Selecione os Professores do curso" class="w-full" />
            </template>

        </Column>
        <Column header="Editar" :rowEditor="true" style="width: 10%; min-width: 8rem" bodyStyle="text-align:center">
        </Column>
    </DataTable>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import { supabase } from '@/supabase';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { FilterMatchMode } from 'primevue/api';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import Toast from 'primevue/toast';
import { useToast } from "primevue/usetoast";
import MultiSelect from 'primevue/multiselect';

const visible = ref(false)
const loading = ref(false)
const cursos = ref([]);
const cursosSelecionados = ref([])
const novoCurso = ref({ anosDoEnsinoMedio: [], professores: [], disciplina: null, anoLetivo: null })
const anosDoEnsinoMedio = ref([
    { label: "1° ano", value: "1" },
    { label: "2° ano", value: "2" },
    { label: "3° ano", value: "3" }
])
const professores = ref([])
const disciplinas = ref([])
const anosLetivos = ref([])

const filters = ref({ global: { value: '', matchMode: FilterMatchMode.CONTAINS } })
const editingRows = ref([])


onMounted(() => {
    listarCursos()
    listarProfessores()
    listarAnosLetivos()
    listarDisciplinas()

});
const testando = (data) => {
    console.log('testando')
    console.log(data)

}
const toast = useToast();
const showToastSuccess = (text) => {
    toast.add({ severity: 'success', detail: text, life: 3000 });
};
const showToastError = (text) => {
    toast.add({ severity: "error", detail: text, life: 3000 });
};

const listarCursos = async () => {
    const { data, error } = await supabase.from('cursos').select(`
            id, anoDoEnsinoMedio, anos_letivos (id, ano), disciplinas (id, nome), cursos_professores (users (id,nome))   
        `).order('id', { ascending: false })
    if (error) {
        showToastError("Ocorreu um erro ao ao listar os cursos")
        return
    }
    cursos.value = data;
}

const excluirCursos = async () => {
    loading.value = true
    let cursosParaDeletar = []
    cursosSelecionados.value.forEach(curso => cursosParaDeletar.push(curso.id))
    const { error } = await supabase.from('cursos').delete().in('id', cursosParaDeletar)
    if (error) { showToastError("Ocorreu um erro ao excluir os cursos"); loading.value = false; return }
    cursosSelecionados.value = []
    loading.value = false
    listarCursos()
}

const inserirCurso = async () => {
    loading.value = true
    for (let ano of novoCurso.value.anosDoEnsinoMedio) {
        let { data, error } = await supabase
            .from('cursos')
            .insert({ anoDoEnsinoMedio: ano, disciplina: novoCurso.value.disciplina, anoLetivo: novoCurso.value.anoLetivo })
            .select()
        const cursoId = data[0].id
        if (error) { showToastError("Ocorreu um erro ao inserir o cursos"); loading.value = false; return }
        if (data.length > 0) {
            let cursoProfessores = novoCurso.value.professores.map(professorId => {
                return { professor: professorId, curso: cursoId }
            })
            let { error } = await supabase.from('cursos_professores').insert(cursoProfessores).select()
            if (error) { showToastError("Ocorreu um erro ao inserir o curso"); loading.value = false; return }
        }
        showToastSuccess("O cursos foi adicionado com sucesso")

    }
    novoCurso.value = { anoDoEnsinoMedio: [], professores: [], disciplina: null, anoLetivo: null }
    listarCursos()
    loading.value = false

}

const listarProfessores = async () => {
    const { data, error } = await supabase
        .from('users')
        .select('id,nome')
        .eq('funcao', 'professor')
        .order('nome')
    professores.value = data
}
const listarDisciplinas = async () => {
    const { data, error } = await supabase
        .from('disciplinas')
        .select('id, nome')
        .order('nome')
    disciplinas.value = data
}
const listarAnosLetivos = async () => {
    const { data, error } = await supabase
        .from('anos_letivos')
        .select('id, ano')
    anosLetivos.value = data

}

const onRowEditSave = async (event) => {
    let { newData } = event;
    let dados = { anoDoEnsinoMedio: newData.anoDoEnsinoMedio, disciplina: newData.disciplinas.id, anoLetivo: newData.anos_letivos.id }
    const { data, error } = await supabase
        .from('cursos')
        .update(dados)
        .eq('id', newData.id)
        .select()
    if (error) {
        showToastError("Ocorreu um erro ao atualizar o curso")
        return
    }

    let cursoProfessores = []
    newData.cursos_professores.forEach(item => {
        if (item.users) {
            alert('Há "null" na lista de professores selecionados. Selecione todos e descelecione para remover o "null"')
            return
        }
        cursoProfessores.push({ curso: newData.id, professor: item })
    })

    const { error2 } = await supabase.from('cursos_professores').delete().eq('curso', newData.id)
    if (error2) {
        showToastError("Ocorreu um erro ao atualizar o curso")
        return
    }
    const { error3 } = await supabase.from('cursos_professores').insert(cursoProfessores).select()
    showToastSuccess('O curso foi atualizado com sucesso')

    listarCursos()


}

const nomesProfessores = (professores) => {
    return professores.map(professor => professor.users.nome).join(', ')
}
const valorParaAno = (ano) => {
    switch (ano) {
        case "1":
            return "1° ano"
            break;
        case "2":
            return "2° ano"
            break
        case "3":
            return "3° ano"
            break
        default: "Sem ano"
            break;
    }
}
</script>